import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { useNavigate } from "react-router-dom";

export default function DeleteAccountModal({ cancelModal }) {
  const { user, dispatch } = useAuthContext();
  const [clubs, setClubs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navi = useNavigate();
  const [input, setInput] = useState("");
  const [inputErr, setInputErr] = useState("");
  const [complete, setComplete] = useState(false);
  //styled
  const handleDelete = async () => {
    setIsLoading(true);
    setInputErr(""); // Reset input error state
    let err = false;

    try {
      if (input !== "Delete my account") {
        err = true;
        setInputErr("Invalid input");
      } else {
        const deleteResponse = await axios.delete(
          `${ApiConnectionString}/api/user`,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (deleteResponse.status === 200) {
          navi("/");
          dispatch({ type: "LOGOUT" });
        } else {
          err = true;
          setInputErr("Failed to delete account");
        }
      }
    } catch (error) {
      console.error("Error deleting account:", error);
      err = true;
      setInputErr("An error occurred. Please try again.");
    } finally {
      setIsLoading(false); // Stop loading regardless of success or failure
      if (err) {
        // Optionally, handle any additional error logic here
      }
    }
  };

  const fetchData = async () => {
    try {
      const clubs = await axios.get(
        `${ApiConnectionString}/api/clubs?OwnerId=${user.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setClubs(clubs.data); // Set the data if the request is successful
    } catch (error) {
      console.error("Error fetching clubs:", error);
      // Optionally, handle the error (e.g., display a message to the user)
    } finally {
      setIsLoading(false); // Stop loading regardless of success or failure
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="send-modal-footer">
            <LoadingSpinner />
          </div>
        </div>
      </div>
    );
  } else {
    if (complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Account Deleted</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>

            <p>Your account has been deleted.</p>

            <div className="send-modal-footer">
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={cancelModal}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      if (clubs.length > 0) {
        return (
          <div className="send-modal-overlay">
            <div className="send-modal">
              <div className="blueBanner">
                <p className="fw-bold m-2 p-2 fontSize20">Delete card</p>
              </div>

              <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
              <p>
                In order to delete your account you must first deactivate the
                following clubs
              </p>
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody>
                  {clubs.map((club) => (
                    <tr
                      key={club.id}
                      onClick={() => navi(`/myoneclub/${club.id}`)}
                    >
                      <td>{club.name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="send-modal-footer">
                <button
                  className="pointer cancelButton fw-bold mx-2 px-3"
                  onClick={cancelModal}
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="send-modal-overlay">
            <div className="send-modal">
              <div className="blueBanner">
                <p className="fw-bold m-2 p-2 fontSize20">Delete card</p>
              </div>

              <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
              <p>
                Type "Delete my account" in the box below and press confirm to
                permanently delete your account.
              </p>

              <div>
                <input
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                />
                {inputErr && <p className="text-danger">{inputErr}</p>}
              </div>
              <div className="send-modal-footer">
                <button className="delete-button mx-3" onClick={handleDelete}>
                  Confirm
                </button>
                <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        );
      }
    }
  }
}
